import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(tableAnatomy.keys);

export const Table = defineMultiStyleConfig({
	baseStyle: {
		th: {
			color: 'text.softer',
			fontWeight: 'medium',
			letterSpacing: 'normal',
			textTransform: 'none',
		},
	},
	sizes: {
		md: {
			th: {
				fontSize: 'sm',
			},
		},
	},
});
